<template>
    <div>
        <template v-if="loading">
            <loading-spinner/>
        </template>

        <x-container fluid app-width v-else>
            <x-layout align-end mb-5>
                <x-flex xs8>
                    <h1>Client assignment management</h1>
                </x-flex>
                <x-flex xs4 text-xs-right mb-2>
                    <x-dialog v-model="newDialog" persistent max-width="600px">
                        <template v-slot:activator="{ on }">
                            <x-btn class="ma-0" color="primary" large v-on="on">New assignment</x-btn>
                        </template>
                        <x-dialog v-model="newDialog" width="800">
                            <new-client-assignment @close="newDialog = false" @assignment-added="fetchData"/>
                        </x-dialog>
                    </x-dialog>
                </x-flex>
            </x-layout>

            <x-layout class="mt-4">
                <x-flex offset-xs6 xs6 pl-2>
                    <x-text-field
                        v-model="searchTerm"
                        placeholder="Search"
                        :append-icon="searchTerm.length === 0 ? 'search' : null"
                        outline
                        clearable
                        hide-details
                    />
                </x-flex>
            </x-layout>

            <x-layout>
                <x-flex xs12>
                    <x-data-table
                        class="no-row-hover"
                        :headers="headers"
                        :items="clientAssignments"
                        :pagination.sync="pagination"
                        hide-actions
                        :custom-filter="customFilter"
                        :search="searchTerm"
                        item-key="id">

                        <template v-slot:no-data>
                            <p class="error-message text-xs-center">No client assignments found</p>
                        </template>

                        <template v-slot:items="{ item }">
                            <tr>
                                <td :inner-html.prop="item.client_company_name | highlightText(searchTerm)"/>
                                <td class="text-xs-left">
                                    <x-tooltip attach nudge-top='unset' nudge-left='unset' v-if="item.client_company.entities.length">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.client_company.entities.length }}</span>
                                        </template>
                                        <div>
                                            <p v-for="entity in item.client_company.entities">
                                                <span :inner-html.prop="' -' + entity.name | highlightText(searchTerm)"/>
                                            </p>
                                        </div>
                                    </x-tooltip>
                                    <span v-else>0</span>
                                </td>
                                <td class="text-xs-center" :inner-html.prop="item.user_name | highlightText(searchTerm)"/>
                                <td class="text-xs-right">
                                    <x-btn
                                        class="ma-0"
                                        color="tertiary"
                                        icon
                                        @click="removeAssignment(item)"
                                    >
                                        <x-icon>close</x-icon>
                                    </x-btn>
                                </td>
                            </tr>
                        </template>
                    </x-data-table>
                </x-flex>
            </x-layout>

            <x-layout mt-5 mb-5>
                <x-flex xs12 text-xs-center>
                    <x-pagination circle v-model="pagination.page" :length="pageCount" :total-visible="15" color="grey-1" />
                </x-flex>
            </x-layout>
        </x-container>
        <modal
            ref="removeAssignment"
            title="Remove assignment"
            confirmation
        >
            <p>Are you sure?</p>
        </modal>
    </div>
</template>

<script>
    import NewClientAssignment from "~/components/Broker/NewClientAssignment";
    import Modal from '~/components/Shared/UIComponents/Modal';

    export default {
        name: "ClientAssignmentDashboard",
        components: {
            NewClientAssignment,
            Modal
        },
        data() {
            return {
                clientAssignments: [],
                loading: true,
                newDialog: false,
                headers: [
                    {
                        text: 'Client Company',
                        align: 'left',
                        sortable: true,
                        value: 'client_company_name'
                    },
                    {
                        text: 'Entity',
                        sortable: true,
                        align: 'left',
                        value: 'client_company.entities'
                    },
                    {
                        text: 'User',
                        align: 'center',
                        sortable: true,
                        value: 'user_name'
                    },
                    {
                        text: 'action',
                        align: 'right',
                        sortable: false,
                        value: ''
                    },
                ],
                newClientAssignment: {
                    name: null,
                    status: 'active'
                },
                pagination: {
                    totalItems: 0,
                    page: 1,
                    rowsPerPage: 10,
                    sortBy: 'client_company_name'
                },
                searchTerm: ''
            }
        },
        computed: {
            pageCount() {
                if (!this.pagination.rowsPerPage || !this.pagination.totalItems) {
                    return 0;
                }

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
            }
        },
        watch: {
            searchTerm(newVal) {
                if (newVal === null) {
                    this.searchTerm = '';
                }
            },
        },
        created() {
            this.fetchData();
        },
        methods: {
            customFilter(items, search, filter) {
                search = search ? search.toString().toLowerCase() : "";
                return items.filter(
                    (item) => item.client_company_name.toString().toLowerCase().search(search) !== -1 ||
                        item.client_company.entities.some((i) => i.name.toString().toLowerCase().search(search)  !== -1) ||
                        item.user_name.toString().toLowerCase().search(search) !== -1
                );
            },
            async fetchData() {
                this.loading = true;
                this.clientAssignments = (await axios.get(this.$root.api(`broker/client-assignment`))).data;
                this.loading = false;
                this.pagination.totalItems  = this.clientAssignments.length
            },
            async removeAssignment(clientAssignment) {
                const body = `Are you sure you want to remove the user ${clientAssignment.user_name} from the client ${clientAssignment.client_company_name}?`;

                if (await this.$refs.removeAssignment.open('Remove Assignment', body) === false) {
                    return;
                }
                this.loading = true;
                axios.delete(this.$root.api(`broker/client-assignment/${clientAssignment.id}`)).then(function(response) {
                    this.clientAssignments = this.clientAssignments.filter(ca => ca.id !== clientAssignment.id);
                    this.pagination.totalItems  = this.clientAssignments.length
                    this.loading = false;
                }.bind(this));
            }
        }
    }
</script>

<style lang="scss" scoped>
    :deep(.x-table) {
        margin-top: 36px;
    }
</style>
